module.exports = __webpack_public_path__ + "img/16581279_L.b451e324.png";